import { ScrollView, StyleSheet, View } from 'react-native'
import { SectionTitle } from '../../app/components/Admin/SectionTitle'
import { DailyReportChart } from '../../app/components/Admin/Reports/DailyReportChart'

const Reports = () => {
  return (
    <ScrollView>
      <View style={styles.container}>
        <SectionTitle title="User Behavior Reports" subtitle="Daily games and hands played by game type" />
        <DailyReportChart />
      </View>
    </ScrollView>
  )
}

export default Reports

const styles = StyleSheet.create({
  container: {
    gap: 32
  }
})
